import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

export const SharepointSettingsState = {
  sharepointSettingsLoading: false,
  sharepointStatus: {},
}

export const SharepointSettingsActions = {
  authorizeSharepoint: async ({ commit }) => {
    commit('setSharepointSettingsLoading', true)

    return axiosRequest.
      patch('/admin/sharepoint/authorize').
      then(({ data }) => data).
      catch(handleError).
      finally(_ => commit('setSharepointSettingsLoading', false))
  },

  deauthorizeSharepoint: async ({ commit }) => {
    commit('setSharepointSettingsLoading', true)

    return axiosRequest.
      delete('/admin/sharepoint/deauthorize').
      then(({ data }) => {
        commit('setSharepointStatus', {})
        return data
      }).
      catch(handleError).
      finally(_ => commit('setSharepointSettingsLoading', false))
  },

  getSharepointStatus: async ({ commit }) => {
    commit('setSharepointSettingsLoading', true)

    return axiosRequest.
      get('/admin/sharepoint/status').
      then(({ data }) => {
        commit('setSharepointStatus', data)
        return data
      }).
      catch(handleError).
      finally(_ => commit('setSharepointSettingsLoading', false))
  },
}

export const SharepointSettingsMutations = {
  setSharepointSettingsLoading: (state, payload) => { state.sharepointSettingsLoading = payload },
  setSharepointStatus: (state, payload) => { state.sharepointStatus = payload },
}

export const SharepointSettingsGetters = {
  sharepointSettingsLoading: state => state.sharepointSettingsLoading,
  sharepointStatus: state => state.sharepointStatus,
}
